import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatThaiDate = (date) => {
    return date.toLocaleDateString("th-TH", {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("th-TH", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <header className="bg-gradient-to-r from-gray-50 to-gray-100 border-b-2 border-primary-500">
      <div className="container-custom py-4">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
          {/* Logo Section */}
          <div className="flex items-center gap-4">
            <img
              src="/assets/dist/img/AdminLTELogo.png"
              alt="SSKRU Logo"
              className="w-16 h-16 object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/64x64?text=SSKRU";
              }}
            />
            <div>
              <h1 className="text-xl lg:text-2xl font-bold text-primary-500">
                งานบริการวิชาการ
              </h1>
              <p className="text-sm text-gray-600">
                สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต
              </p>
              <p className="text-sm text-accent-500 font-medium">
                มหาวิทยาลัยราชภัฏศรีสะเกษ
              </p>
            </div>
          </div>

          {/* Info Section */}
          <div className="text-center lg:text-right">
            <div className="mb-2 text-gray-600">
              <i className="fas fa-calendar-alt text-primary-500 mr-2"></i>
              <span className="text-sm">{formatThaiDate(currentTime)}</span>
            </div>
            <div className="mb-3 text-gray-600">
              <i className="fas fa-clock text-primary-500 mr-2"></i>
              <span className="text-sm">{formatTime(currentTime)}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
